import React from 'react'
import PropTypes from 'prop-types'
import DatePicker from 'react-datepicker'
import moment from 'moment'

import 'react-datepicker/dist/react-datepicker.css'

class RenderDatePicker extends React.Component {
    format = 'DD.MM.YYYY';

    constructor (props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange (date) {
        if (!date || !moment(date).isValid()) {
            this.props.input.onChange(null);
            return;
        }
        this.props.input.onChange(moment(date).format(this.format));
    }

    render () {
        const {
            input, placeholder,
            meta: {touched, error}
        } = this.props;

        let wrapperClassName = 'form-group has-required mb-0';
        let inputClassName = 'form-control';
        
        if (error || !input.value) {
            inputClassName += ' form-control-required is-invalid';
        } else if (input.value && moment(input.value, this.format)) {
            wrapperClassName += ' has-success';
            inputClassName += ' form-control-success is-valid';
        }

        return (
            <div className={wrapperClassName}>
                <DatePicker
                    placeholder={placeholder}
                    dateFormat={this.format}
                    selected={input.value ? moment(input.value, this.format) : null}
                    minDate={this.props.minDate ? moment(this.props.minDate, this.format) : null}
                    maxDate={this.props.maxDate ? moment(this.props.maxDate, this.format) : null}
                    onChange={this.handleChange}
                    peekNextMonth
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode='select'
                    className={inputClassName}
                />
                {touched && error && <span>{error}</span>}
            </div>
        )
    }
}

RenderDatePicker.propTypes = {
    input: PropTypes.shape({
        onChange: PropTypes.func.isRequired,
        value: PropTypes.string.isRequired
    }).isRequired,
    meta: PropTypes.shape({
        touched: PropTypes.bool,
        error: PropTypes.string
    }),
    placeholder: PropTypes.string,
    maxDate: PropTypes.string,
    minDate: PropTypes.string,
};

RenderDatePicker.defaultProps = {
    placeholder: ''
};

export default RenderDatePicker



// WEBPACK FOOTER //
// ./src/components/RenderDatePicker.js